import { actions } from '../actions';
import { orderIterations } from 'common/utils/utils';
import { formatIterationRange } from 'state/selectors/iterations-picker';
const initialState = [];

export const iterationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_ITERATIONS_SUCCEED:
      const orderedIterations = orderIterations(action.payload);

      return [
        ...orderedIterations,
        /**
         * Combine a number of iterations together
         */
        ...[3, 5, 8, 10]
          /**
           * Only combine if we have enough iterations
           */
          .filter(numIterations => orderedIterations.length >= numIterations)

          /**
           * Map each combination to start and end dates
           */
          .map(numIterations => ({
            name: `Last ${numIterations} Iterations`,
            start_date: orderedIterations[numIterations - 1].start_date,
            end_date: orderedIterations[0].end_date,
            isComputed: true
          }))
      ]
        .map(iteration => ({
          ...iteration,
          ...{
            isVisible:
              (iteration.isComputed && action.options.withComputed) ||
              !iteration.isComputed
          }
        }))
        .map(iteration => {
          const range = formatIterationRange(iteration);

          return {
            ...iteration,
            computedName: `${iteration.name} (${range})`,
            range
          };
        });
    case actions.SET_ITERATIONS:
      return action.payload;

    default:
      return state;
  }
};
